
import { Instance, types, getRoot, getSnapshot, applySnapshot } from 'mobx-state-tree'
import { IStore } from "../"

export const Plate = types
    .model("Plate", {
        img: types.maybeNull(types.string),
        id: types.string,
        randId: types.string,
        name: types.maybeNull(types.string),
        description: "",
        color: types.string,
        material: types.string,
        size: types.maybeNull(types.string),
        category: types.string,
        count: 0,
        price: 0,
    })
export const HouseAreaPlates = types
    .model("HouseAreaPlates", {
        security: types.maybeNull(Plate),
        animal: types.maybeNull(Plate),
        noAnimal:types.maybeNull(Plate),
        smoking: types.maybeNull(Plate),
        childPlace: types.maybeNull(Plate),
        childRools: types.maybeNull(Plate),
        noParking: types.maybeNull(Plate),
        attanChild: types.maybeNull(Plate),
        speedLimit: types.maybeNull(Plate),
        noSignal: types.maybeNull(Plate),
    }).actions(self => ({
        changeSecurityCount: (count: number) => {
            self.security!.count = count
        },
        changeAnimalCount: (count: number) => {
            self.animal!.count = count
        },
        changeNoAnimalCount: (count: number) => {
            self.noAnimal!.count = count
        },
        changeSmokingCount: (count: number) => {
            self.smoking!.count = count
        },
        changeChildPlaceCount: (count: number) => {
            self.childPlace!.count = count
        },
        changeChildRoolsCount: (count: number) => {
            self.childRools!.count = count
        },
        changeNoParkingCount: (count: number) => {
            self.noParking!.count = count
        },
        changeAttanChildCount: (count: number) => {
            self.attanChild!.count = count
        },
        changeSpeedLimitCount: (count: number) => {
            self.speedLimit!.count = count
        },
        changeNoSignalCount: (count: number) => {
            self.noSignal!.count = count
        },
    })).views(self => ({
        get allPrice() {
            return self.security!.count * self.security!.price +
            self.animal!.count * self.animal!.price +
            self.noAnimal!.count * self.noAnimal!.price +
            self.smoking!.count * self.smoking!.price + 
            self.childPlace!.count * self.childPlace!.price + 
            self.childRools!.count * self.childRools!.price + 
            self.noParking!.count * self.noParking!.price +
            self.attanChild!.count * self.attanChild!.price +
            self.speedLimit!.count * self.speedLimit!.price +
            self.noSignal!.count * self.noSignal!.price 
        }
    }))

export const ParkingPlates = types.model("ParkingPlates",{
    parkingPlate: types.maybeNull(Plate),
    parkingNumber: types.maybeNull(Plate)
}).actions(self => ({
    changeParkingPlateCount: (count: number) => {
        self.parkingPlate!.count = count
    },
    changeParkingNumberCount: (count: number) => {
        self.parkingNumber!.count = count
    }
})).views(self => ({
    get allPrice() {
        return self.parkingPlate!.count * self.parkingPlate!.price +
        self.parkingNumber!.count * self.parkingNumber!.price
    }
}))

export interface IAnshlag extends Instance<typeof Plate> { }

export const Anshlag = types
    .model("Anshlag", {
        houseAreaPlates: types.optional(HouseAreaPlates, {}),
        parkingPlates: types.optional(ParkingPlates, {}),
        plates: types.array(Plate),
    }).actions(self => ({
        addPlates: (count: number, size: string, color: string, matelial: string, name: string, plate: any, descr: string) => {
            //let newArr = self.plates.get(size)
            self.plates.push(Plate.create({
                randId: String(Math.round(new Date().getTime())),
                id: String(plate.id),
                img: plate.img,
                count: count,
                color: color,
                material: matelial,
                price: Number(plate.price),
                size: plate.size,
                description: descr,
                name: plate.name,
                category:""
            }))
        },

    })).views(self => ({
        get fullAnshlagPrice(){
            let fullprice = 0
            self.plates.forEach((pl) => {
                fullprice = fullprice + +pl.price * pl.count
            })
            return fullprice + self.houseAreaPlates.allPrice + self.parkingPlates.allPrice
        }
    })).actions(self => ({
        toBasket: () =>{
            self.plates.forEach(pl =>{(getRoot(self) as IStore).BusketStore.addProduct(pl, pl.count, 0, 0, pl.description)});

            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.security, self.houseAreaPlates.security?.count as number, 0,0, self.houseAreaPlates.security?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.animal, self.houseAreaPlates.animal?.count as number, 0,0, self.houseAreaPlates.animal?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.noAnimal, self.houseAreaPlates.noAnimal?.count as number, 0,0, self.houseAreaPlates.noAnimal?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.smoking, self.houseAreaPlates.smoking?.count as number, 0,0, self.houseAreaPlates.smoking?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.childPlace, self.houseAreaPlates.childPlace?.count as number, 0,0, self.houseAreaPlates.childPlace?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.childRools, self.houseAreaPlates.childRools?.count as number, 0,0, self.houseAreaPlates.childRools?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.noParking, self.houseAreaPlates.noParking?.count as number, 0,0, self.houseAreaPlates.noParking?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.attanChild, self.houseAreaPlates.attanChild?.count as number, 0,0, self.houseAreaPlates.attanChild?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.speedLimit, self.houseAreaPlates.speedLimit?.count as number, 0,0, self.houseAreaPlates.speedLimit?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.houseAreaPlates.noSignal, self.houseAreaPlates.noSignal?.count as number, 0,0, self.houseAreaPlates.noSignal?.description);
            
            (getRoot(self) as IStore).BusketStore.addProduct(self.parkingPlates.parkingPlate, self.parkingPlates.parkingPlate?.count as number, 0,0, self.parkingPlates.parkingPlate?.description);
            (getRoot(self) as IStore).BusketStore.addProduct(self.parkingPlates.parkingNumber, self.parkingPlates.parkingNumber?.count as number, 0,0, self.parkingPlates.parkingNumber?.description);
        }
    }))
    .actions(self => ({
        afterCreate() {
            if (localStorage.getItem("anshlag")) {
                applySnapshot(self, JSON.parse(localStorage.getItem("anshlag") || ""))
            }
        }
    }))
